import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/"
)({
  beforeLoad({ params }) {
    throw redirect({
      to: "/orgs/$organizationId/projects/$projectId/auth/oauth",
      params,
    });
  },
  loader: () => ({
    crumb: "Auth",
  }),
});
